/**
 * Sets up the section buttons for the sub navigation.
 * @function
 * @returns {void}
 */

import { scrollTop } from "../helpers/scrollTop";

export function setupSectionButtons() {
    const navSubsections = document.querySelector(".nav-items--subsections");
    const buttons = navSubsections.querySelectorAll(".item");
    const mainContainer = document.querySelector(".has-sections");

    const sections = Array.from(
        mainContainer.querySelectorAll("div[id^='section-']"),
    );

    console.log("sections", sections);

    buttons.forEach((button) => {
        console.log("button", button);
        button.addEventListener("click", () => {
            scrollTop();
            const targetSectionId = button.getAttribute("data-sections");
            const targetSection = document.getElementById(targetSectionId);

            if (targetSection) {
                sections.forEach((section) => {
                    section.setAttribute("hidden", true);
                });

                targetSection.removeAttribute("hidden");

                buttons.forEach((btn) => {
                    btn.classList.remove("active");
                });

                button.classList.add("active");
            }
        });
    });
}
